import { createFileRoute } from "@tanstack/react-router";
import { OAuthCallbackPage } from "@/features/auth/OAuthCallbackPage";
import { z } from "zod";

const searchSchema = z.object({
  code: z.string().optional(),
  state: z.string().optional(),
  error: z.string().optional(),
});

export const Route = createFileRoute("/auth/callback")({
  validateSearch: searchSchema,
  component: OAuthCallbackPage,
});
